import React, { FunctionComponent } from "react";
import { Modal } from "react-bootstrap";

type OwnProps = {
  showModal?: boolean;
  onHide: () => any;
  isCoach?: boolean;
  isTeacher?: boolean;
};

type Props = OwnProps;

const GatherEvidenceModal: FunctionComponent<Props> = (props) => {
  return (
    <Modal
      id="gather-evidence-modal"
      show={props.showModal}
      animation={false}
      size="lg"
      centered
      backdropClassName="customDarkModalBackdrop in"
      onHide={props.onHide}
    >
      <Modal.Header closeButton className={"purpleModalHeader"}>
        <Modal.Title className="modalTitle">{props.isTeacher ? 'View' : 'Gather'} Evidence</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.isCoach ? <p className="text-center">
          Add evidence by uploading files or entering data manually.
        </p> : ''}
        <p className="text-center">
          All evidence is managed in the <strong><i>My Data</i></strong> menu, 
          where entries are displayed in an easy-to-read, Excel-style table.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default GatherEvidenceModal;
